module.exports = __webpack_public_path__ + "img/qr_code_blur.5472357f.svg";